import * as React from "react"
import { SVGProps } from "react"

interface InfoIconProps extends SVGProps<SVGSVGElement> {
  stroke?: string;
}

const InfoIcon = ({ stroke = "#fff", ...props }: InfoIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props}>
    <g
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      data-name="Group 18936"
    >
      <path d="M1 10a9 9 0 1 0 9-9 9 9 0 0 0-9 9" data-name="Path 6018" />
      <path d="M10 7h.01" data-name="Path 6019" />
      <path d="M9 10h1v4h1" data-name="Path 6020" />
    </g>
  </svg>
)

export default InfoIcon